@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.accounts.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.accounts.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        <app-input-block [invalid]="isInvalid('name')" controlId="name" controlName="name" labelKey="pages.accounts.fields.name">
          @if (hasError('name', 'required') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.name-required' | translate }}</div>
          }
          @if (hasError('name', 'maxlength') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.name-maxlength' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [invalid]="isInvalid('webUrl')" controlId="web-url" controlName="webUrl" labelKey="pages.accounts.fields.web-url">
          @if (hasError('webUrl', 'maxlength') && isInvalid('webUrl')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.web-url-maxlength' | translate }}</div>
          }
          @if (hasError('webUrl', 'url') && isInvalid('webUrl')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.web-url-format' | translate }}</div>
          }
        </app-input-block>

        <app-input-block
          [fullWidth]="true"
          [invalid]="isInvalid('logoUrl')"
          controlId="logo-url"
          controlName="logoUrl"
          labelKey="pages.accounts.fields.logo-url"
        >
          @if (hasError('logoUrl', 'maxlength') && isInvalid('logoUrl')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.logo-url-maxlength' | translate }}</div>
          }
          @if (hasError('logoUrl', 'url') && isInvalid('logoUrl')) {
          <div class="invalid-feedback">{{ 'pages.accounts.validation.logo-url-format' | translate }}</div>
          }
        </app-input-block>

        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at" labelKey="pages.accounts.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at" labelKey="pages.accounts.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        <button class="btn btn-light" [disabled]="saving()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.accounts.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.accounts.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
